export class SmallPopover {
  constructor(el) {
    this.el = el;
    this.options = {
      mode: 'click',
      boundary: el.closest('.swiper-container') || window,
      pos: 'top-left',
      animation: 'uk-animation-slide-top-small',
      duration: 500
    };
    const tagOptions = el.dataset.popover ? Object.fromEntries(el.dataset.popover.split(';').map(item => item.split(':')).map(item => item.map(item => item.trim()))) : {};
    this.options = Object.assign(tagOptions, this.options)
  }
  init() {
    const dropWrapper = document.createElement('div');
    dropWrapper.classList.add('popover-wrapper');
    dropWrapper.style.width = this.el.offsetWidth + 'px';
    dropWrapper.innerHTML = `<div></div><div class="b-popover b-popover_${this.options.size || ''} popover-text"></div>`;
    this.el.insertAdjacentElement('afterend', dropWrapper);
    this.dropEl = dropWrapper.children[1];
    this.drop = UIkit.drop(this.dropEl, this.options);
    this.inited = true;
  }
  setText(text) {
    this.dropEl.innerHTML = text
  }
  toggle() {
    this.drop.show();
    setTimeout(() => this.drop.hide(500), 2500);
  }
}
